module.exports = __webpack_public_path__ + "img/wedding-17.05c11336.jpg";